import React, { forwardRef, useImperativeHandle } from "react"
import {Grid} from "semantic-ui-react"
import DropDown from "../../../components/commonComponents/formComponents/dropDown";
import { operationCode } from "./mockConstants";
import InputField from '../../../components/commonComponents/formComponents/inputField';

const ErrorMock = forwardRef((props, ref) => {
    
    const [errorCode, setErrorCode] = React.useState("");
    const [errorDescription, setErrorDescription] = React.useState("");
    const [errorItemNumber, setErrorItemNumber] = React.useState("");
    const [errorItemOrderNumber, setErrorItemOrderNumber] = React.useState("");
    const [errorLabel, setErrorLabel] = React.useState("");
    const [errorValue, setErrorValue] = React.useState("");

    useImperativeHandle(ref, () => ({
        getErrorData: () =>  ({
            errorCode,
            errorDescription,
            errorItemNumber,
            errorItemOrderNumber,
            errorLabel,
            errorValue
        })
    }));

    return (
        <>
            <Grid.Row className="entry-number-row entry-number-row-padding">
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Code"
                        value={errorCode}
                        onChange={(value) => setErrorCode(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Description"
                        value={errorDescription}
                        onChange={(value) => setErrorDescription(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Item Number"
                        value={errorItemNumber}
                        onChange={(value) => setErrorItemNumber(value)}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row className="entry-number-row entry-number-row-padding">
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Item Order Number"
                        value={errorItemOrderNumber}
                        onChange={(value) => setErrorItemOrderNumber(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Label"
                        value={errorLabel}
                        onChange={(value) => setErrorLabel(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Value"
                        value={errorValue}
                        onChange={(value) => setErrorValue(value)}
                    />
                </Grid.Column>
            </Grid.Row>
        </>
     );
})
 
export default ErrorMock;